import React from "react";

/**
 * Reusable confirmation modal with the same style as DeleteModal/UploadImageModal
 *
 * @param {string} message - The message to display
 * @param {function} onConfirm - Called when user clicks Yes/Confirm
 * @param {function} onCancel - Called when user clicks Cancel
 * @param {string} confirmText - Text for confirm button (default: "Yes")
 * @param {string} cancelText - Text for cancel button (default: "Cancel")
 * @param {boolean} danger - If true, confirm button is red instead of green
 */
export default function ConfirmModal({
  message,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "Cancel",
  danger = false
}) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10000000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          width: "80vw",
          maxWidth: "500px",
          background: "white",
          border: "3px solid #000000",
          padding: "20px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
          fontSize: "24px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p style={{ margin: "0 0 20px 0", color: "black" }}>{message}</p>
        <div
          style={{
            marginTop: "15px",
            fontSize: "18px",
            display: "flex",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          <button
            onClick={onConfirm}
            style={{
              padding: "10px 20px",
              backgroundColor: danger ? "#ef4444" : "#26EF96",
              color: danger ? "white" : "black",
              border: "none",
              cursor: "pointer",
              flex: 1,
              fontFamily: "DM Mono, monospace",
              fontSize: "16px",
            }}
          >
            {confirmText}
          </button>
          <button
            onClick={onCancel}
            style={{
              border: "3px solid #000000",
              padding: "10px 20px",
              cursor: "pointer",
              flex: 1,
              background: "white",
              color: "black",
              fontFamily: "DM Mono, monospace",
              fontSize: "16px",
            }}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
}
